module.exports = __webpack_public_path__ + "static/media/chevron-right.4ea6753a.svg";